<template>
  <div class="modal-container">
    <div class="inner-modal" v-on-clickaway="closeModal">
      <div style="border-right:0.5px solid lightgray" class="modal-inner-vertical">
        <!--UPLOAD-->
        <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving" class="input-form">
          <h1 style="font-family: 'DINPro Bold'">Upload Image</h1>
          <div class="dropbox">
            <input
              type="file"
              :name="uploadFieldName"
              :disabled="isSaving"
              @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
              accept="image/*"
              class="input-file"
            >
            <p v-if="isInitial" style="font-family: 'DINPro Light'; color:white">
              Drag your file(s) here to begin
              <br>or click to browse
            </p>
            <v-progress-circular :size="70" :width="7" color="white" indeterminate v-if="isSaving"></v-progress-circular>
          </div>
        </form>
        <img v-if="success" :src="fileUrl" style="height: auto;width: 80%; max-width: 30rem;">
      </div>

      <div style="border-right:0.5px solid lightgray" class="modal-inner-vertical">
        <div class="input-save-container">
          <v-text-field v-model="title" label="Title" required></v-text-field>
          <v-btn color="primary" dark @click="saveCatagory" :loading="loading" style="margin-top: 2rem;">Save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import { CMS } from "../../../api";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "add-catagory",
  mixins: [clickaway],
  created() {},
  mounted() {
    this.reset();
  },
  data: function() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photo",
      fileUrl: "",
      success: false,
      title: "",
      loading: false
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    closeModal() {
      this.$store.dispatch("updateShowingModal", { active: false, name: "" });
    },

    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(file, name) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      CMS.getSignedUrl(this, file, response => {
        if (response && response.data && response.data.signedRequest) {
          this.fileUrl = `https://s3.amazonaws.com/marofsb/images/${
            response.data.filename
          }`;
          this.uploadToS3(file, response.data.signedRequest);
        } else alert("danger will robinson, we have an error");
      });
    },
    uploadToS3(file, signedRequest) {
      CMS.uploadToS3(this, file, signedRequest, response => {
        if (parseInt(response.status) == 200) {
          this.success = true;
          this.currentStatus = STATUS_SUCCESS;
          return;
        }
        alert("something failed, cody sucks, try again");
      });
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.save(fileList[0]);
    },
    saveCatagory() {
        let { title, fileUrl } = this
        if (!title || title == '' || !fileUrl || fileUrl == '') alert('missing stuff')
        else {
            CMS.saveCatagory(this, {title: title, imageUrl: fileUrl}, response => {
                if (parseInt(response.status) == 200) {
                    CMS.getCatagories(this, response => {})
                    this.closeModal()
                    return
                }
                alert('something went wrong saving')
            })
        }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropbox {
  outline: 2px dashed white; /* the dash box */
  outline-offset: -10px;
  background: #3d3d3d;
  color: dimgray;
  padding: 2rem;
  min-height: 200px; /* minimum height */
  position: relative;
  width: 100%;
  cursor: pointer;
  margin-top: 2rem;
  transition: ease all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  box-shadow: 6px 6px 10px #3d3d3d; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.input-form, .input-save-container {
  width: 40rem;
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: flex-start;
  padding: 3rem;
}

</style>


// WEBPACK FOOTER //
// AddCatagory.vue?edeab864